import * as actions from "./actions";

export default function processingReducer(state = false, action) {
    switch (action.type) {

    case actions.SET_PROCESSING_START:
    case actions.SET_PROCESSING_STOP:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
